// src/components/GalleryPanel.jsx
import React, { useContext } from 'react';
import './GalleryPanel.css';
import { MediaOverlayContext } from '../../context/MediaOverlayContext';

const GalleryPanel = ({ layout = 'horizontal', editable = true, filterByPetId = null }) => {
  const {
    photos,
    updatePhotoAtIndex,
    availableDogs,
    galleryLayout,
    setActivePhotoIndex,
  } = useContext(MediaOverlayContext);

  const resolvedLayout = layout || galleryLayout || 'horizontal';

  const visiblePhotos = filterByPetId
    ? photos.filter(photo => photo.tags.some(tag => tag.id === filterByPetId))
    : photos;

  const updateChecklist = (index, field, value) => {
    const updatedChecklist = {
      ...photos[index].checklist,
      [field]: value,
    };
    updatePhotoAtIndex(index, { checklist: updatedChecklist });
  };

  const addTag = (index, dogId) => {
    if (!photos[index].tags.some(tag => tag.id === dogId)) {
      const dog = availableDogs.find(d => d.id === dogId);
      updatePhotoAtIndex(index, { tags: [...photos[index].tags, dog] });
    }
  };

  const removeTag = (index, dogId) => {
    updatePhotoAtIndex(index, {
      tags: photos[index].tags.filter(tag => tag.id !== dogId),
    });
  };

  return (
    <div className={`gallery-panel gallery-${resolvedLayout}`}>
      {visiblePhotos.map((photo, idx) => (
        <div
          key={idx}
          className="photo-card"
          onClick={() => setActivePhotoIndex(idx)}
          style={{ cursor: 'pointer' }}
        >
          <button type="button" className="card-open-link" onClick={(e) => { e.stopPropagation(); setActivePhotoIndex(idx); }}>
            View snapshot {idx + 1}
          </button>
          <img
            src={photo.src}
            alt={`Snapshot ${idx + 1}`}
            className="gallery-photo-preview"
          />

          {editable && resolvedLayout !== 'horizontal' && (
            <>
              <div className="tag-section">
                <label>Tag Dogs:</label>
                <select
                  value=""
                  onChange={(e) => {
                    const selectedId = parseInt(e.target.value);
                    if (selectedId) addTag(idx, selectedId);
                  }}
                >
                  <option value="">Select a dog...</option>
                  {availableDogs.map(dog => (
                    <option key={dog.id} value={dog.id}>{dog.name}</option>
                  ))}
                </select>

                {photo.tags.length > 0 && (
                  <div className="tagged-dogs-list">
                    {photo.tags.map(tag => (
                      <span key={tag.id} className="tag-badge">
                        {tag.name}
                        <button onClick={() => removeTag(idx, tag.id)}>✕</button>
                      </span>
                    ))}
                  </div>
                )}
              </div>

              <div className="checklist-section">
                {[
                  ['playing', 'Dogs playing'],
                  ['relaxing', 'Dogs relaxing'],
                  ['noFence', 'No green fence'],
                  ['doorClosed', 'Back door closed'],
                  ['noCollars', 'No bark collars'],
                  ['noPoop', 'No poop'],
                  ['limitDogs', '≤ 5 dogs']
                ].map(([key, label]) => (
                  <label key={key}>
                    <input
                      type="checkbox"
                      checked={photo.checklist[key]}
                      onChange={(e) => updateChecklist(idx, key, e.target.checked)}
                    /> {label}
                  </label>
                ))}

                <label>
                  <input
                    type="checkbox"
                    checked={photo.checklist.instaWorthy}
                    onChange={(e) => updateChecklist(idx, 'instaWorthy', e.target.checked)}
                  /> Instagram worthy
                </label>

                {photo.checklist.instaWorthy && (
                  <input
                    type="text"
                    placeholder="Instagram caption"
                    value={photo.checklist.instaCaption}
                    onChange={(e) => updateChecklist(idx, 'instaCaption', e.target.value)}
                  />
                )}

                <input
                  type="text"
                  placeholder="Rover caption"
                  value={photo.checklist.roverCaption}
                  onChange={(e) => updateChecklist(idx, 'roverCaption', e.target.value)}
                />
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default GalleryPanel;
